import AResponseFlowSummaryItem from './index.vue';

AResponseFlowSummaryItem.install = app => {
  app.component(AResponseFlowSummaryItem.name, AResponseFlowSummaryItem);
};

export default AResponseFlowSummaryItem;
